import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCrw-lhJgqd9Fuxu6DAxY3xQfOuAAaNJjc",
  authDomain: "trackliohub-cc1f8.firebaseapp.com",
  projectId: "trackliohub-cc1f8",
  storageBucket: "trackliohub-cc1f8.firebasestorage.app",
  messagingSenderId: "760868650995",
  appId: "1:760868650995:web:4d12016126ccecf2ef9c86",
  measurementId: "G-H073G5QKKN"
};

const app = initializeApp(firebaseConfig);

// Analytics sirf supported browsers me initialize hoga
isSupported().then((supported) => {
  if (supported) {
    getAnalytics(app);
  }
});

export default app;